"use client";

import { ErrorScreen, ErrorScreenProps } from "@rmh/ui";

export default function GlobalError({ error }: ErrorScreenProps) {
  return (
    <html lang="en-US" style={{ height: "100%", width: "100%" }}>
      <body style={{ height: "100%", width: "100%" }}>
        <ErrorScreen error={error} />
      </body>
    </html>
  );
}
